import { makeRequest } from '../../../../../api/makeRequest';

export const rejectIncomingInvite = (data) => makeRequest({
  url: '/sebTariff/rejectInvite/',
  method: 'post',
  headers: {
    'content-type': 'application/json',
  },
  data,
});
